export default "__VITE_ASSET__DTuRk9vt__"